import type { Side } from "@design-lab/shared";
import { useArtwork } from "./useArtwork";
import { useArtworkForm } from "./useArtworkForm";

export function useClearManualEdits() {
  const { getMachineBySide } = useArtwork();
  const { form } = useArtworkForm();

  return (side: Side) => {
    // Clear the form flag
    form.setValue(`info.${side}.editImageManual`, false, { shouldDirty: true });

    // Clear the artwork machine's manualEditUrl
    const machine = getMachineBySide(side);
    const ctx = machine.state.context as any;
    if (ctx?.artwork) {
      const updatedArtwork = { ...ctx.artwork, manualEditUrl: null };
      machine.send({
        type: "reset",
        targetState: "finished",
        context: { ...ctx, artwork: updatedArtwork }
      });
    }
  };
}
